import { type DateFormat } from './types';

const SHORT_DATE = 'dd/MM/yyyy';
const SHORT_DATE_TIME = 'dd/MM/yyyy HH:mm';
const YEAR_MONTH = 'MM-yyyy';

const DATE_FORMATS: Record<DateFormat, string> = {
  short: SHORT_DATE,
  shortDateTime: SHORT_DATE_TIME,
  yearMonth: YEAR_MONTH,
};

export { DATE_FORMATS };
